import { SpecimenType } from 'src/types';

// URL-friendly mapping for specimen types
export const SPECIMEN_TYPE_URL_MAP: Record<SpecimenType, string> = {
  [SpecimenType.ProstateBiopsy]: 'prostate_biopsy',
  [SpecimenType.BreastBiopsy]: 'breast_biopsy',
  [SpecimenType.ProstatePostRp]: 'prostate_post_rp',
  [SpecimenType.ColorectalCancer]: 'colorectal_cancer',
  [SpecimenType.MetastaticProstateBiopsy]: 'metastatic_prostate_biopsy',
};
